import React from "react";
import classNames from "classnames";
import { Link, useHistory } from "react-router-dom";
import Icon from "../../theme/untitled/icons/Icon";
import Button from "../../theme/untitled/Button/Button";

/**
 * One configuration-checklist tile. Not a stepper — no connector line, no
 * locking; `number` is a label, not a sequence position.
 *
 * @param {Object} props
 * @param {number} props.number
 * @param {"done"|"next"|"not-started"} props.state
 * @param {string} props.title
 * @param {string} props.explanation
 * @param {boolean=false} props.optional
 * @param {string=} props.linkUrl - omitted when the step has no in-app action (e.g. email activation)
 * @param {string} props.ctaLabel
 */
const Tile = ({
  number,
  state,
  title,
  explanation,
  optional = false,
  linkUrl,
  ctaLabel,
}) => {
  const history = useHistory();

  let bottomSlot;
  if (state === "done") {
    bottomSlot = <span className="cfg-tag">Done</span>;
  } else if (!linkUrl) {
    // No in-app action for this step (e.g. account activation happens via
    // an emailed link) — show a plain status hint instead of a dead CTA.
    bottomSlot = (
      <div className="cfg-cta">
        <span className="cfg-cta--muted">{ctaLabel}</span>
      </div>
    );
  } else if (state === "next") {
    bottomSlot = (
      <div className="cfg-cta">
        <Button
          hierarchy="primary"
          size="sm"
          onClick={() => history.push(linkUrl)}
        >
          {ctaLabel}
        </Button>
      </div>
    );
  } else {
    bottomSlot = (
      <div className="cfg-cta">
        <Link to={linkUrl} className="cfg-link">
          {ctaLabel}
          <Icon name="ArrowNarrowRight" size={16} />
        </Link>
      </div>
    );
  }

  return (
    <div
      className={classNames("cfg-tile", {
        "cfg-tile--done": state === "done",
        "cfg-tile--next": state === "next",
      })}
    >
      <div className="cfg-tile-top">
        <span
          className={classNames("cfg-mark", {
            "cfg-mark--done": state === "done",
            "cfg-mark--next": state === "next",
          })}
        >
          {state === "done" ? <Icon name="Check" size={15} /> : number}
        </span>
        {optional && <span className="cfg-opt">Optional</span>}
      </div>
      <span className="cfg-title">{title}</span>
      <p className="cfg-explanation">{explanation}</p>
      {bottomSlot}
    </div>
  );
};

export default Tile;
